import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from './AxiosClient'

export const getInventoryAsync = createAsyncThunk(
  'dashboard/inventoryanalysis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/summary-dashboard/inventory-analysis-summary', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getImportAsync = createAsyncThunk(
  'dashboard/importanalysis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/summary-dashboard/import-analysis-summary', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get Competitor Analysis Map Data
export const getSuppliersByCountries = createAsyncThunk(
  'competitoranalysis/worldmap',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/competitor-analysis-dashboard/competitors-weight-distribution`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Get Competitor Analysis Map Data
export const getSuppliersByCountriesForDonut = createAsyncThunk(
  'competitoranalysis/donut',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/competitor-analysis-dashboard/competitors-weight-distribution`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getChartDataLeftChart = createAsyncThunk(
  'competitoranalysis/barchartleft',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/competitor-analysis-dashboard/competitors-weight-distribution`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
export const getChartDataRightChart = createAsyncThunk(
  'competitoranalysis/barchartright',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/competitor-analysis-dashboard/competitors-weight-distribution`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Get Competitor Analysis Filters
export const getCompetitorAnalysisFilters = createAsyncThunk(
  'competitoranalysis/filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/competitor-analysis-dashboard/get-filters`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get Competitor Table data
export const getCompetitorTableData = createAsyncThunk(
  'competitoranalysis/tableData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      `v1/competitor-analysis-dashboard/HS-code-analysis-by-country`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Get top regions by company
export const getTopRegionsbyCompany = createAsyncThunk(
  'competitoranalysis/regiondonuts',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      `/v1/competitor-analysis-dashboard/get-top-regions-by-company`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//Get IndiviSupplier Information in Scorecard
export const getIndividualSupplierInformation = createAsyncThunk(
  'scorecard/supplierinformation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/risk-analytics/scorecard/get-supplier-information`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const alternativeSuppliersByProduct = createAsyncThunk(
  'scorecard/alernatesupplersbyproduct',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/supplier-scorecard/alternative-suppliers-by-supplier`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getSupplierEmail = createAsyncThunk(
  'scorecard/get-supplier-email',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/supplier-scorecard/get-supplier-email`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getProductBySupplier = createAsyncThunk(
  'scorecard/productbysuppliers',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/supplier-scorecard/product-by-this-supplier`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getAlternateSuppliers = createAsyncThunk(
  'scorecard/alernatesuppliers',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/supplier-scorecard/alternative-suppliers`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSuppilerDetailsandExposures = createAsyncThunk(
  'scorecard/supplierdetailsandexposures',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/supplier-scorecard/supplier-details-and-exposures`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
export const getProductCategory = createAsyncThunk(
  'summarydashboard/productCategory',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      `/v1/summary-dashboard/product-category-wise-avg-risks`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getTopSelectionSupplier = createAsyncThunk(
  'alix/topselection',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `v1/top-selection/suppliers/get-suppliers-information`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getRiskSelectionData = createAsyncThunk(
  'config/riskselection',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-selection/risk/get-risk-config-information`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)
export const getupdateRiskData = createAsyncThunk(
  'config/updaterisk',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('PATCH', `/v1/risk-selection/risk/update-risk-config`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getCountryList = createAsyncThunk(
  'alix/allcountrylist',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/top-selection/suppliers/get-country-list`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const uploadProductsDataFromExcel = createAsyncThunk(
  'datamanagement/uploadexcel',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/rfi-rfp/upload-suppliers/upload_supplier_template`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getDrillDownData = createAsyncThunk(
  'scorecard/drilldowntable',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/supplier-scorecard/alternative-suppliers-drill-down-by-risk-type`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getLineChart = createAsyncThunk(
  'scorecard/line-chart',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/supplier-scorecard/get-line-chart`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
///////////////////////////////////////////////////////////////////////////////////////

///////////////////ICR COMMODITY///////////////////////////
export const getIcrCommodityTableDataAsync = createAsyncThunk(
  'icrCommodity/getIcrCommodityTableData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/icr/commodities`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getIcrCommodityFormTableDataAsync = createAsyncThunk(
  'icrCommodity/getIcrCommodityFormTableData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/commodities`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const createCommoditityAsync = createAsyncThunk(
  'icrCommodity/createCommoditity',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/icr/createcommoditity`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//////////////////////////////////////////ICR BASKET//////////////////////////////////////
////////levels///////////
export const getCommoditiesDataAsync = createAsyncThunk(
  'icrBasket/getCommoditiesData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/commodities`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getLevel1DataAsync = createAsyncThunk(
  'icrBasket/getLevel1Data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/commodity/level1`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getLevel2DataAsync = createAsyncThunk(
  'icrBasket/getLevel2Data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/commodity/level2`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getLevel3DataAsync = createAsyncThunk(
  'icrBasket/getLevel3Data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/commodity/level3`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getCountryDataAsync = createAsyncThunk(
  'icrBasket/getCountryData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/commodity/country`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

////////basket///////////
export const getBasketAsync = createAsyncThunk(
  'icrBasket/getBasket',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/icrBasket`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const createBasketAsync = createAsyncThunk(
  'icrBasket/createBasket',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/create/icrBasket`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const deleteBasketAsync = createAsyncThunk(
  'icrBasket/deleteBasket',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/ICR/deleteBasket`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

////////commodity///////////
export const getIcrBasketCommodityTableDataAsync = createAsyncThunk(
  'icrBasket/getIcrBasketCommodityTableData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/icr/geticrbasketcommodity${payload}`, [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const deleteIcrBasketCommodityTableDataAsync = createAsyncThunk(
  'icrBasket/deleteIcrBasketCommodityTableData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/ICR/deleteBasketCommodity`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const addIcrBasketCommodityTableDataAsync = createAsyncThunk(
  'icrBasket/addIcrBasketCommodityTableData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/create/BasketCommodity`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const UpdateIcrBasketCommodityTableDataAsync = createAsyncThunk(
  'icrBasket/UpdateIcrBasketCommodityTableData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/ICR/updateICRBasketCommodity`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const setIndividualSupplierInformation = createAsyncThunk(
  'suppliers-info/save',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/risk-analytics/scorecard/set-supplier-information`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getConfigSettingInfo = createAsyncThunk(
  'config/app-settings',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    let url = `/v1/configurations/app-settings`

    return await AxiosClient('GET', url, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const updateConfigSettingInfo = createAsyncThunk(
  'config/app-settings',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('PUT', `/v1/configurations/update-app-settings`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getCountriesAndDatabase = createAsyncThunk(
  'config/get-countries-and-database',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      `/v1/supplier-intelligence/datamyne-config-countries`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const setCountriesAndDatabase = createAsyncThunk(
  'config/set-countries-and-database',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      `/v1/supplier-intelligence/set-config-datamyne-country`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const fetchSavedDatamyneCountry = createAsyncThunk(
  'config/fetch-saved-datamyne-country',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      `/v1/supplier-intelligence/fetch-datamyne-user-config-country-db`,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const savePortalVerbiageConfiguration = createAsyncThunk(
  'v1/rfx-analysis/save-configurable-verbiage',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/rfx-analysis/save-configurable-verbage`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getAllConfigurableverbaige = createAsyncThunk(
  'v1/rfx-analysis/get-all-configurable-verbage',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/rfx-analysis/get-configurable-verbage`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const updateUserSettings = createAsyncThunk(
  'configurations/update-user-settings',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/configurations/update-user-settings`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// check user onboarding
export const getUserOnBoardingAsync = createAsyncThunk(
  'on-boarding-setting/user-onboarding-process',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/cost-modelling/user-onboarding-process', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// dismiss user onboarding
export const dismissUserOnBoardingAsync = createAsyncThunk(
  'on-boarding-setting/dismiss-user-onboarding-process',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/cost-modelling/dismiss-onboarding-process', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const refreshLogLevel = createAsyncThunk(
  'v1/refresh-log-level',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/refresh-log-level`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const uploadTopDownModelChunkAsync = createAsyncThunk(
  '/v1/upload-utility/upload-chunk',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/upload-utility/upload-chunk', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const finalizeTopDownModelUploadAsync = createAsyncThunk(
  '/v1/upload-utility/finalize-upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/upload-utility/finalize-upload', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
